import { FC } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';

interface ModalProps {
    visible: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
}

const CloseIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 5C28.2843 5 35 11.7157 35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5ZM15.4043 13.54C14.9162 13.052 14.1249 13.0521 13.6367 13.54C13.1486 14.0282 13.1486 14.8195 13.6367 15.3076L18.251 19.9219L13.6494 24.5234C13.1616 25.0116 13.1614 25.803 13.6494 26.291C14.1375 26.7789 14.9289 26.7788 15.417 26.291L20.0186 21.6895L24.6035 26.2744C25.0917 26.7624 25.883 26.7625 26.3711 26.2744C26.8589 25.7863 26.859 24.9949 26.3711 24.5068L21.7861 19.9219L26.3838 15.3242C26.8717 14.8361 26.8717 14.0448 26.3838 13.5566C25.8957 13.0685 25.1044 13.0686 24.6162 13.5566L20.0186 18.1543L15.4043 13.54Z"
            fill="black"
        />
    </svg>
);

const Modal: FC<ModalProps> = ({ visible, onClose, title, children }) => {
    if (!visible) return null;

    return createPortal(
        <div className={styles.modal}>
            <div className="modal-overlay" onClick={onClose} />
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">{title}</h3>
                    <button className="modal-close" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="modal-content">{children}</div>
            </div>
        </div>,
        document.body,
    );
};

export default Modal;
